import * as type from "../types/universal";

const initialState = {
  errorNotification: null,
  successNotification: null,
  showModals: {
    resubscribeModal: false,
    newSpaceModal: false,
  },
};

export const universal = (state = initialState, payload) => {
  switch (payload.type) {
    case type.SET_NOTIFICATION:
      if (payload.message.type === "error") {
        return {
          ...state,
          errorNotification: payload.message.content,
        };
      } else if (payload.message.type === "success") {
        return {
          ...state,
          successNotification: payload.message.content,
        };
      } else {
        return state;
      }
    case type.RESET_NOTIFICATION:
      return {
        ...state,
        errorNotification: null,
        successNotification: null,
      };
    case type.CHANGE_UNIVERSAL_MODALS:
      if (
        payload.modal.newSpaceModal === true ||
        payload.modal.newSpaceModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            newSpaceModal: payload.modal.newSpaceModal,
          },
        };
      } else if (
        payload.modal.resubscribeModal === true ||
        payload.modal.resubscribeModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            resubscribeModal: payload.modal.resubscribeModal,
          },
        };
      } else {
        return state;
      }
    default:
      return state;
  }
};
